import { render } from "./index.vue?vue&type=template&id=3015ff3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3015ff3c&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3015ff3c"],['__file',"src/views/order/products/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3015ff3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3015ff3c', __exports__)) {
    console.log('reload')
    api.reload('3015ff3c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3015ff3c&scoped=true", () => {
    console.log('re-render')
    api.rerender('3015ff3c', render)
  })

}


export default __exports__